export default __webpack_public_path__ + "static/media/pb55.bfbdd533.png";